module.exports = __webpack_public_path__ + "static/media/BNHA.4cc46c79.png";